import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, formatError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=guest, obj=user
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const login = async (email, password) => {
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data);
      return true;
    } catch (e) {
      setError(formatError(e.response?.data?.detail) || e.message);
      return false;
    }
  };

  const register = async (name, email, password, phone = "", agreedTerms = false, handle = "") => {
    setError("");
    try {
      const { data } = await api.post("/auth/register", { name, email, password, phone, agreed_terms: agreedTerms, handle });
      setUser(data);
      return true;
    } catch (e) {
      setError(formatError(e.response?.data?.detail) || e.message);
      return false;
    }
  };

  const resendVerification = async () => {
    try { await api.post("/auth/resend-verification"); return true; } catch { return false; }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, error, login, register, logout, resendVerification, reload: load }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
